import Image from 'next/image'
import Link from 'next/link'
import React, { ComponentPropsWithoutRef } from 'react'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { ArrowNextCarousel } from '~shared/icons/arrow-next-carousel'
import { cn } from '~shared/utils/cn'

interface CategoriesSectionProps extends ComponentPropsWithoutRef<'section'> {
  categories: Awaited<ReturnType<typeof getCategoriesData>>
}

export const CategoriesSection: React.FC<CategoriesSectionProps> = props => {
  const { className = '', categories } = props
  return (
    <section className={cn('container container-slim', className)}>
      <div className='container'>
        <h2 className='typo-section-heading typo-section-heading-mb'>
          Уровни образования
        </h2>
        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-[16px]'>
          {categories?.categories
            ?.slice()
            .sort((a, b) => (a?.rank ?? Infinity) - (b?.rank ?? Infinity))
            ?.filter(item => item.slug !== 'gruppa-vyhodnogo-dnya')
            .map(el => {
              const effectiveDiscount = el?.discount || null
              return (
              <Link
                href={
                  ['bakalavriat', 'magistratura', 'kursy', 'college'].includes(
                    el?.slug ?? ''
                  )
                    ? `/programs/${el?.slug}`
                    : `/${el.slug}`
                }
                key={el.slug}
                prefetch={false}
                className='relative rounded-[24px] bg-[#F2F2F2] text-black group hover:bg-[#3A52EE] hover:text-white duration-300 ease-out p-[4px] md:p-[16px] cursor-pointer'>
                {effectiveDiscount ? (
                  <span className='absolute top-[8px] right-[8px] md:top-[24px] md:right-[24px] z-10 bg-[#FF543C] text-white text-[12px] md:text-[14px] font-medium rounded-[24px] px-[8px] py-[4px]'>
                    -{effectiveDiscount}%
                  </span>
                ) : null}
                <div className='py-[5px] md:p-[16px] rounded-[24px] bg-white flex items-center justify-center'>
                  <Image
                    src={el?.image?.url ?? ''}
                    alt={el.name ?? 'mitm category image'}
                    width={170}
                    height={170}
                    className='h-[100px] w-[100px]
                    md:h-[170px] md:w-[170px]
                    2xl:h-[230px] 2xl:w-[230px]'
                  />
                </div>
                <div className='flex justify-between items-center mt-[20px] mb-[16px] px-[12px] md:px-0 md:mb-0'>
                  <p className='font-medium text-[14px] md:text-[16px]'>
                    {el.name}
                  </p>
                  <span className='duration-300 ease-out w-[24px] h-[24px] rounded-[50%] bg-black flex items-center justify-center group-hover:bg-white'>
                    <ArrowNextCarousel className='text-white group-hover:text-[#3A52EE]' />
                  </span>
                </div>
              </Link>
              )
            })}
        </div>
      </div>
    </section>
  )
}
